












































































import Vue from 'vue'

export default Vue.extend({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    use: {
      type: String,
      default: 'primary',
    },
    type: {
      type: String,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed:{
    eventsItems(){
      return this.$listeners
    },
  }
})
